import api from './api';

export interface SelectionItem {
  selection_id: string;
  product_id: string;
  product?: any;
}

export interface Selection {
  id: string;
  user_id: string;
  status: 'draft' | 'submitted';
  created_at: string;
  items: SelectionItem[];
  user?: any;
  calculated_price?: {
    total_price: string;
    total_weight: number;
    total_items: number;
  };
}

export interface GetSelectionsParams {
  page?: number;
  page_size?: number;
  status?: string;
}

export interface GetSelectionsResponse {
  data: Selection[];
  meta: {
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
  };
}

export const selectionService = {
  getAll: (params: GetSelectionsParams) => {
    return api.get<GetSelectionsResponse>('/admin/selections', { params });
  },

  getById: (id: string) => {
    return api.get<{ data: Selection }>(`/selections/${id}`);
  },

  // User methods
  getActive: () => {
    return api.get<{ data: Selection }>('/selections/active');
  },

  submit: () => {
    return api.post<{ data: Selection }>('/selections/submit');
  },

  getHistory: (params: GetSelectionsParams = {}) => {
    return api.get<{ data: Selection[], meta: any }>('/selections/history', { params });
  },

  toggleLike: (productId: string) => {
    return api.post('/selections/toggle', { product_id: productId });
  },

  generateShareImage: (id: string) => {
    return api.get<{ image_url: string }>(`/selections/${id}/share`);
  },

  updateStatus: (id: string, status: string) => {
    return api.patch(`/admin/selections/${id}/status`, { status });
  }
};
